import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddNewProgramFormModel } from '../../AddNewProgram.types'
import { FieldSection } from '../../formSection/fieldSection/FieldSection'

import { Checkbox } from '@percent/lemonade'
import { AgentVerification } from './agentVerification/AgentVerification'
import { Compliance } from './compliance/Compliance'
import { FraudCheck } from './fraudCheck/FraudCheck'
import { Eligibility } from './eligibility/Eligibility'

export function Checks() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [validationRequestCheck] = useWatch({
    control,
    name: ['validationRequestCheck']
  })

  return (
    <FieldSection title={t('form.checks')}>
      <Checkbox
        variant="default"
        active={!!validationRequestCheck}
        name="validationRequest"
        label={t('form.validationRequest')}
        onChange={event => {
          const isChecked = (event as React.ChangeEvent<HTMLInputElement>).target.checked
          setValue('validationRequestCheck', isChecked ? { type: 'validation_request' } : undefined)
        }}
      />
      <AgentVerification />
      <Compliance />
      <Eligibility />
      <FraudCheck />
    </FieldSection>
  )
}
